import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS - 3);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-31" data-mp="ant8i1dy1vw4">
      <div className="mx-auto flex max-w-5xl flex-nowrap items-center justify-center gap-1.5 whitespace-nowrap px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.06em] sm:gap-2 sm:px-4 sm:py-2 sm:text-xs sm:tracking-[0.14em]" data-id="element-32" data-mp="6nit5y49ht4l">
        <HourglassIcon className="h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-33" data-mp="18dwq43noxplo" />
        <span data-id="element-34" data-mp="uf5f4q44kk1r">
          <span className="sm:hidden" data-id="element-35" data-mp="uff9epw7ddd9">Offer ends in:</span>
          <span className="hidden sm:inline" data-id="element-36" data-mp="yfz1vg5tzst2">Launch offer ends in:</span>
        </span>
        <span className="flex items-center gap-0.5 tabular-nums sm:gap-1" aria-live="off" data-id="element-37" data-mp="1m48kyabnu2gi">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-0.5 sm:gap-1" data-id="element-38" data-mp="1r5fvgh56tfqv" data-mpi={index}>
              <span className="text-xs font-extrabold sm:text-base" data-id="element-39" data-mp="1hd9z6v7wkc5v">
                {pad(unit.value)}
              </span>
              <span className="text-[8px] tracking-normal opacity-90 sm:text-[9px]" data-id="element-40" data-mp="252ktpuyntabk">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="opacity-70 sm:px-0.5" data-id="element-41" data-mp="2jqcvt1zljedp">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}